import manifest from './macDownloadRelease.json';
import { parseMacDownloadManifest } from '@/lib/macDownloadManifest.cjs';

// Written automatically after successful Mac publication and refreshed before
// web exports. /mac also checks the live manifest so deployed pages stay current.
export const MAC_DOWNLOAD_RELEASE = parseMacDownloadManifest(manifest);
const override = (process.env.EXPO_PUBLIC_MAC_DOWNLOAD_URL || '').trim();
// Only the verified production installer may override automatic updates.
export const MAC_DOWNLOAD_OVERRIDE = override && override === MAC_DOWNLOAD_RELEASE?.url ? override : null;
export const MAC_DOWNLOAD_URL = MAC_DOWNLOAD_OVERRIDE || MAC_DOWNLOAD_RELEASE?.url || null;
